import { render, staticRenderFns } from "./clueFollow.vue?vue&type=template&id=25963f86&scoped=true"
import script from "./clueFollow.vue?vue&type=script&lang=js"
export * from "./clueFollow.vue?vue&type=script&lang=js"
import style0 from "./clueFollow.vue?vue&type=style&index=0&id=25963f86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25963f86",
  null
  
)

export default component.exports